// This is the order we are asked to sort the manuals
// newest year
// english
// assembly
// material
// parts
// operator parts
// operator
//Each sort is its own function, sorting by that key and leaving it in place if its not equal to that key
export function ModelYear(fileKey, fileKeyB, manualList) {
  if (
    manualList.manual_files[fileKey].field_model_year != undefined &&
    manualList.manual_files[fileKey].field_model_year.length > 0 &&
    manualList.manual_files[fileKeyB].field_model_year != undefined &&
    manualList.manual_files[fileKeyB].field_model_year.length
  ) {
    if (
      manualList.manual_files[fileKey].field_model_year >
      manualList.manual_files[fileKeyB].field_model_year
    ) {
      return 1;
    }
    if (
      manualList.manual_files[fileKey].field_model_year <
      manualList.manual_files[fileKeyB].field_model_year
    ) {
      return -1;
    } else return 0;
  } else return 0;
}

export function EnglishFirst(fileKey, fileKeyB, manualList) {
  if (
    manualList.manual_files[fileKey].field_manual_language_final.includes(
      "English"
    )
  ) {
    return 1;
  }
  if (
    manualList.manual_files[fileKeyB].field_manual_language_final.includes(
      "English"
    )
  ) {
    return -1;
  }

  return 0;
}

export function AssemblySort(fileKey, fileKeyB, manualList) {
  if (
    manualList.manual_files[fileKey].field_manual_type_final.includes(
      "Assembly"
    )
  ) {
    return -1;
  }
  if (
    manualList.manual_files[fileKeyB].field_manual_type_final.includes(
      "Assembly"
    )
  ) {
    return 1;
  }
  return 0;
}
export function MaterialSort(fileKey, fileKeyB, manualList) {
  if (
    manualList.manual_files[fileKey].field_manual_type_final.includes(
      "Material"
    )
  ) {
    return -1;
  }
  if (
    manualList.manual_files[fileKeyB].field_manual_type_final.includes(
      "Material"
    )
  ) {
    return 1;
  }
  return 0;
}
export function PartsSort(fileKey, fileKeyB, manualList) {
  if (
    manualList.manual_files[fileKey].field_manual_type_final.includes("Parts")
  ) {
    return -1;
  }
  if (
    manualList.manual_files[fileKeyB].field_manual_type_final.includes("Parts")
  ) {
    return 1;
  }
  return 0;
}
export function OperatorPartsSort(fileKey, fileKeyB, manualList) {
  if (
    manualList.manual_files[fileKey].field_manual_type_final.includes(
      "Operator / Parts"
    )
  ) {
    return -1;
  }
  if (
    manualList.manual_files[fileKeyB].field_manual_type_final.includes(
      "Operator / Parts"
    )
  ) {
    return 1;
  }
  return 0;
}
export function OperatorSort(fileKey, fileKeyB, manualList) {
  if (
    manualList.manual_files[fileKey].field_manual_type_final.includes(
      "Operator"
    )
  ) {
    return -1;
  }
  if (
    manualList.manual_files[fileKeyB].field_manual_type_final.includes(
      "Operator"
    )
  ) {
    return 1;
  }
  return 0;
}
